import React, { Fragment } from "react";
import {
  Grid,
  TextField,
  Typography,
  Select,
  Input,
  InputLabel,
  MenuItem,
  Button,
  InputAdornment,
  Tooltip,
  IconButton,
  FormControl,
  FormHelperText,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import LoopIcon from "@mui/icons-material/Loop";
import InfoIcon from "@mui/icons-material/Info";

const Fees = (props) => {
  const {
    feeInfo,
    feesMethod,
    feesType,
    product,
    feesBase,
    companyLocations,
    handleChangeProductFee,
    handleChangeFee,
    handleClickAddFee,
    handleClickDeleteFee,
  } = props;

  const handleSwitchPrice = () => {
    const feeProductUnitPrice =
      feeInfo.productData &&
      (feeInfo.productData.weight_type === "" ||
        feeInfo.productData.weight_type === null)
        ? feeInfo.productData.base_unit_price
        : feeInfo.productData.base_unit_price_per_lb;

    const feeProductCasePrice =
      feeInfo.productData &&
      (feeInfo.productData.weight_type === "" ||
        feeInfo.productData.weight_type === null)
        ? feeInfo.productData.base_case_price
        : feeInfo.productData.base_case_price_per_lb;

    const unitOPrice = feeProductUnitPrice || product.unit_price;
    const caseOPrice = feeProductCasePrice || product.case_price;

    const newOPrice =
      feeInfo.oprice === "" || feeInfo.oprice !== unitOPrice
        ? unitOPrice
        : caseOPrice;

    handleChangeFee({ target: { name: "oprice", value: newOPrice } });
  };

  return (
    <form margin="dense" noValidate autoComplete="off">
      <Typography
        color="primary"
        component="h4"
        style={{ marginTop: 24, alignItems: "center", textAlign: "center" }}
      >
        <b>{`${feesBase === 0 ? "Product Wide" : "Per Location"} margins`}</b>
        <Tooltip title="Final Price is the price of the product that the customer sees on their order guide after all margins (company location and per product) have been applied. Base Price is the price of the product after company location margins have been applied">
          <IconButton>
            <InfoIcon />
          </IconButton>
        </Tooltip>
      </Typography>
      <br />
      <br />
      {product.margins.length === 0 ||
      product.margins.every((item) => item.deleted) ? (
        <Typography
          color="primary"
          component="h4"
          style={{ textAlign: "center" }}
        >
          <b>There are no margins added</b>
        </Typography>
      ) : (
        <Grid container spacing={2} alignItems="center">
          {product.margins
            .filter((item) => !item.hidden)
            .map((item) => (
              <Fragment key={"margin-" + item.id}>
                {!item.deleted ? (
                  <>
                    <Grid
                      container
                      spacing={2}
                      alignItems="center"
                      sx={{
                        marginTop: 2,
                        background: "#f9f9f9",
                        paddingRight: item.category !== null ? 2 : 2,
                        paddingBottom: 3,
                        border: "1px solid #aaa",
                        borderRadius: 3,
                      }}
                    >
                      <Grid item xs={true} sm={true}>
                        <Typography color="primary" component="h4">
                          {`Margin ${item.id || "new"}`}
                        </Typography>
                      </Grid>
                      <Grid item xs={"auto"} sm={"auto"}>
                        <Tooltip title="Delete">
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              handleClickDeleteFee(`margin-${item.id}`)
                            }
                            sx={{ color: "red" }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sx={{ padding: "0 !important" }}
                      ></Grid>
                      <Grid item xs={12} sm={3}>
                        <InputLabel shrink id="calculationMethodLabel">
                          Calculation Method
                        </InputLabel>
                        <Select
                          fullWidth
                          name={"margin-type-" + item.id}
                          input={<Input />}
                          value={item.type && item.type}
                          onChange={handleChangeProductFee("margin", item.id)}
                        >
                          {feesMethod.map((item) => (
                            <MenuItem
                              key={"margin-type-" + item.id + "-" + item}
                              value={item}
                            >
                              {item === "f" ? "Flat" : "Percentage"}
                            </MenuItem>
                          ))}
                        </Select>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          fullWidth
                          type="number"
                          size="small"
                          required={true}
                          variant="outlined"
                          label={`${item.type !== "f" ? "Percentage" : "Flat"}`}
                          name={"margin-amount-" + item.id}
                          InputProps={{
                            startAdornment: ["", "f"].includes(item.type) ? (
                              <InputAdornment position="start">
                                $
                              </InputAdornment>
                            ) : (
                              <></>
                            ),
                            endAdornment: !["", "f"].includes(item.type) ? (
                              <InputAdornment position="start">
                                %
                              </InputAdornment>
                            ) : (
                              <></>
                            ),
                          }}
                          value={item.amount && item.amount}
                          onChange={handleChangeProductFee("margin", item.id)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          fullWidth
                          type="number"
                          size="small"
                          required={true}
                          variant="outlined"
                          label="Final Price"
                          name={"margin-aprice-" + item.id}
                          value={item.aprice && item.aprice}
                          onChange={handleChangeProductFee("margin", item.id)}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <TextField
                          fullWidth
                          type="number"
                          size="small"
                          variant="outlined"
                          label="Base Price"
                          name={"margin-oprice-" + item.id}
                          value={item.oprice && item.oprice}
                          style={{ background: "#eee" }}
                          disabled={true}
                          sx={{
                            "& .MuiInputBase-input.Mui-disabled": {
                              opacity: 1,
                              WebkitTextFillColor: "#000",
                            },
                            "& .MuiInputLabel-root.Mui-disabled": {
                              color: "rgba(0, 0, 0, 0.6)",
                            },
                            "& .MuiOutlinedInput-notchedOutline.Mui-disabled": {
                              borderColor: "rgba(0, 0, 0, 0.23)",
                            },
                          }}
                        />
                      </Grid>
                      {feesBase === 1 ? (
                        <Grid item xs={12} sm={6}>
                          <InputLabel shrink id="company_location_label">
                            Customer Location
                          </InputLabel>
                          <Select
                            fullWidth
                            name={"margin-company_location-" + item.id}
                            input={<Input />}
                            value={item && item.company_location}
                            onChange={handleChangeProductFee("margin", item.id)}
                          >
                            <MenuItem value="">
                              <em>- None -</em>
                            </MenuItem>
                            {companyLocations.map((item) => (
                              <MenuItem
                                key={`company_location_${item.id}`}
                                value={item.id}
                              >
                                {`${item.name}`}
                              </MenuItem>
                            ))}
                          </Select>
                        </Grid>
                      ) : (
                        <></>
                      )}
                      <Grid item xs={12} sm={true}>
                        <TextField
                          fullWidth
                          size="small"
                          required={true}
                          variant="outlined"
                          label="Description"
                          name={"margin-description-" + item.id}
                          value={(item.description && item.description) || ""}
                          onChange={handleChangeProductFee("margin", item.id)}
                        />
                      </Grid>
                    </Grid>
                  </>
                ) : (
                  <></>
                )}
              </Fragment>
            ))}
        </Grid>
      )}
      {/* <Typography
        color="primary"
        component="h4"
        style={{ alignItems: "center", marginTop: 24, textAlign: "center" }}
      >
        <b>Surcharges</b>
      </Typography>
      {product.surcharges.length === 0 ||
      product.surcharges.every((item) => item.deleted) ? (
        <Typography
          color="primary"
          component="h4"
          style={{ textAlign: "center" }}
        >
          <b>There are no surcharges added</b>
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {product.surcharges.map((item, item.id) => (
            <Fragment key={"surcharge-" + item.id}>
              {!item.deleted ? (
                <>
                  <Grid item xs={12} sm={12}>
                    <Typography
                      color="primary"
                      component="h4"
                      style={{ textAlign: "center" }}
                    >
                      {`Surcharge ${item.id || "new"}`}
                      <Tooltip title="Delete">
                        <IconButton
                          aria-label="delete"
                          onClick={() =>
                            handleClickDeleteFee(`margin-${item.id}`)
                          }
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputLabel shrink id="calculationMethodLabel">
                      Calculation Method
                    </InputLabel>
                    <Select
                      fullWidth
                      name={"surcharge-type-" + item.id}
                      input={<Input />}
                      value={item.type && item.type}
                      onChange={handleChangeProductFee("surcharge", item.id)}
                    >
                      {feesMethod.map((item) => (
                        <MenuItem
                          key={"surcharge-type-" + item.id + "-" + item}
                          value={item}
                        >
                          {item === "f" ? "Flat" : "Percentage"}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      type="number"
                      size="small"
                      required={true}
                      variant="outlined"
                      label={`${item.type !== "flat" ? "Percentage" : "Flat"}`}
                      name={"surcharge-amount-" + item.id}
                      InputProps={{
                        startAdornment: ["", "f"].includes(item.type) ? (
                          <InputAdornment position="start">$</InputAdornment>
                        ) : (
                          <></>
                        ),
                        endAdornment: !["", "f"].includes(item.type) ? (
                          <InputAdornment position="start">%</InputAdornment>
                        ) : (
                          <></>
                        ),
                      }}
                      value={item.amount && item.amount}
                      onChange={handleChangeProductFee("surcharge", item.id)}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <InputLabel shrink id="warehouseLabel">
                      Warehouse
                    </InputLabel>
                    <Select
                      fullWidth
                      name={"surcharge-warehouseId-" + item.id}
                      input={<Input />}
                      value={item && item.warehouseId}
                      onChange={handleChangeProductFee("surcharge", item.id)}
                    >
                      {warehouses.map((warehouse) => (
                        <MenuItem
                          key={
                            "surcharge-warehouseId-" +
                            item.id +
                            "-" +
                            warehouse.id
                          }
                          value={warehouse.id}
                        >
                          {warehouse.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>
                  <Grid item xs={12} sm={true}>
                    <TextField
                      fullWidth
                      size="small"
                      required={true}
                      variant="outlined"
                      label="Description"
                      name={"surcharge-description-" + item.id}
                      value={item.description && item.description}
                      onChange={handleChangeProductFee("surcharge", item.id)}
                    />
                  </Grid>
                </>
              ) : (
                <></>
              )}
            </Fragment>
          ))}
        </Grid>
      )} */}
      <Grid
        container
        spacing={2}
        style={{ alignItems: "center", marginTop: 24 }}
      >
        {/* <Grid
          item
          xs={12}
          style={{ textAlign: "center", alignContent: "center" }}
        >
          <Button
            variant="text"
            color={feesBase === 0 ? "primary" : "inherit"}
            onClick={() => handleChangeFeesBase(0)}
          >
            Product Wide
          </Button>
          <Button
            variant="text"
            color={feesBase === 1 ? "primary" : "inherit"}
            onClick={() => handleChangeFeesBase(1)}
          >
            Per Location
          </Button>
        </Grid> */}
        <Grid
          container
          alignItems={"center"}
          style={{ justifyContent: "center" }}
        >
          <Typography color="primary" component="h4">
            Add a fee with the following information
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          {feesType.length > 0 && (
            <>
              <InputLabel shrink id="feeTypeLabel">
                Fee Type
              </InputLabel>
              <Select
                fullWidth
                key="fee_type"
                name="fee_type"
                input={<Input />}
                value={feeInfo && feeInfo.fee_type}
                onChange={handleChangeFee}
              >
                {feesType.map((item) => (
                  <MenuItem key={"fee_type-" + item} value={item}>
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel shrink id="calculationMethodLabel">
            Calculation Method
          </InputLabel>
          <Select
            fullWidth
            key="type"
            name="type"
            input={<Input />}
            value={feeInfo && feeInfo.type}
            onChange={handleChangeFee}
          >
            {feesMethod.map((item) => (
              <MenuItem key={"type_" + item} value={item}>
                {item === "f" ? "Flat" : "Percentage"}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            type="number"
            size="small"
            id="amount"
            variant="outlined"
            label={`${
              ["", "f"].includes(feeInfo.type) ? "Flat" : "Percentage"
            }`}
            name="amount"
            InputProps={{
              startAdornment: ["", "f"].includes(feeInfo.type) ? (
                <InputAdornment position="start">$</InputAdornment>
              ) : (
                <></>
              ),
              endAdornment: !["", "f"].includes(feeInfo.type) ? (
                <InputAdornment position="start">%</InputAdornment>
              ) : (
                <></>
              ),
            }}
            value={feeInfo && feeInfo.amount}
            onChange={handleChangeFee}
            disabled={!feeInfo.company_location}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            type="number"
            size="small"
            id="final_price"
            variant="outlined"
            label="Final Price"
            name="aprice"
            value={feeInfo && feeInfo.aprice}
            onChange={handleChangeFee}
            disabled={!feeInfo.company_location}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={product && product.unit_type === "Unit / Case" ? 3 : 4}
        >
          <TextField
            fullWidth
            type="number"
            size="small"
            id="base_price"
            variant="outlined"
            label="Base Price"
            name="oprice"
            value={feeInfo && feeInfo.oprice}
            aria-readonly="true"
            style={{ background: "#eee" }}
            disabled={true}
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                opacity: 1,
                WebkitTextFillColor: "#000",
              },
              "& .MuiInputLabel-root.Mui-disabled": {
                color: "rgba(0, 0, 0, 0.6)",
              },
              "& .MuiOutlinedInput-notchedOutline.Mui-disabled": {
                borderColor: "rgba(0, 0, 0, 0.23)",
              },
            }}
          />
        </Grid>
        {product && product.unit_type === "Unit / Case" && (
          <Grid item xs={12} sm={1}>
            <Tooltip title="Switch Unit Type Price">
              <IconButton
                aria-label="switch"
                onClick={() => handleSwitchPrice()}
              >
                <LoopIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        )}
        {feesBase === 1 ? (
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth size="small">
              <InputLabel
                shrink
                id="company_location_label"
                style={{ marginLeft: -14 }}
              >
                Customer Location
              </InputLabel>
              <Select
                fullWidth
                name="company_location"
                input={<Input />}
                value={feeInfo && feeInfo.company_location}
                onChange={handleChangeFee}
              >
                <MenuItem value="">
                  <em>- None -</em>
                </MenuItem>
                {companyLocations.map((item) => (
                  <MenuItem key={`company_location_${item.id}`} value={item.id}>
                    {`${item.name}`}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText style={{ marginLeft: 0 }}>
                Select a customer location first to unlock Flat and Final Price
                fields
              </FormHelperText>
            </FormControl>
          </Grid>
        ) : (
          <></>
        )}
        <Grid item xs={12} sm={feesBase === 1 ? 6 : 12}>
          <TextField
            fullWidth
            size="small"
            id="description"
            variant="outlined"
            label="Description"
            name="description"
            value={feeInfo && feeInfo.description}
            onChange={handleChangeFee}
          />
        </Grid>
        <Grid container style={{ justifyContent: "flex-end" }}>
          <Button
            style={{
              minWidth: "auto",
              marginTop: 10,
              padding: "6px 10px",
            }}
            variant="contained"
            color="primary"
            onClick={handleClickAddFee}
            disabled={
              feeInfo.type === "" ||
              feeInfo.amount === "" ||
              feeInfo.warehouse === ""
            }
          >
            Add
            {`${
              ["", "margin"].includes(feeInfo.fee_type)
                ? " Margin"
                : " Surcharge"
            }`}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default Fees;
